import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import PersistJob from './add_job';
import PersistServiceAgreement from './persist_service_agreement';

// The New/Edit job and service agreement forms, each in a side panel
// (components/FormDrawer). Opened by `store.isOpen`; `jobStore.isServiceAgreement`
// picks the form.
//
// Each time the panel opens the form is mounted afresh (new `key`), so its
// defaults, uncontrolled fields and local state start over, as they did when
// the form was only rendered while open. After closing it stays mounted (with
// the same form type) so the panel can slide out instead of vanishing.
@inject('store', 'jobStore') @observer
class AddNewJob extends Component {
  openCount = 0;
  wasOpen = false;
  showServiceAgreement = false;

  render() {
    const { isOpen } = this.props.store;
    if (isOpen && !this.wasOpen) {
      this.openCount += 1;
    }
    this.wasOpen = isOpen;
    if (isOpen) {
      this.showServiceAgreement = this.props.jobStore.isServiceAgreement;
    }
    if (this.openCount === 0) {
      return null;
    }

    const Form = this.showServiceAgreement ? PersistServiceAgreement : PersistJob;
    return <Form key={this.openCount} isOpen={isOpen} onClose={this.props.onClose} />;
  }

};

export default AddNewJob;
